// apps/web/src/lib/validators/vehicle.ts
import { z } from "zod";
// FIX: Changed the import source for WeightUnit to use the shared types package
import { WeightUnit } from "@logistics-platform/types";

// Single-file schema (images or PDFs)
const fileSchema = z
	.instanceof(File, { message: "Please upload a valid file." })
	.refine(
		(file) => file.size <= 5 * 1024 * 1024,
		"File size cannot exceed 5MB."
	);

export const CreateVehicleSchema = z.object({
	make: z.string().min(2, "Vehicle make must be at least 2 characters long."),
	model: z.string().min(1, "Vehicle model is required."),
	licensePlate: z
		.string()
		.min(3, "License plate must be at least 3 characters long."),

	capacity: z
		.number({ invalid_type_error: "Capacity must be a number." })
		.positive("Capacity must be a positive number."),
	capacityUnit: z.nativeEnum(WeightUnit),

	galleryImages: z
		.array(fileSchema)
		.min(1, "At least one gallery image is required.")
		.max(5, "You can upload a maximum of 5 images."),

	registrationDocument: fileSchema,
	ownershipDocument: fileSchema,
});

export type TCreateVehicleSchema = z.infer<typeof CreateVehicleSchema>;
